<div class="tree_readio_list">
  <mat-tree class="tree_radio_item" [dataSource]="dataSource" [treeControl]="treeControl">
    <mat-tree-node [style.display]="searchText && hideLeafNode(node) && !showParentNode(node)? 'none' : 'flex'"
      [class.selected]="isSelected(node)" class="has_padding" *matTreeNodeDef="let node" matTreeNodePadding>
      <mat-radio-button [labelPosition]="'before'" [checked]="isSelected(node)" (change)="selectNode(node)">
        {{node.name}}
      </mat-radio-button>
    </mat-tree-node>

    <mat-tree-node [class.selected]="isSelected(node)"
      [style.display]="hideParentNode(node) && hideLeafNode(node) ? 'none' : 'flex'"
      *matTreeNodeDef="let node; when: hasChild" class="has_padding" matTreeNodePadding>
      <button mat-icon-button matTreeNodeToggle type="button">
        <mat-icon class="mat-icon-rtl-mirror">
          {{treeControl.isExpanded(node) ? 'expand_less' : 'expand_more'}}
        </mat-icon>
      </button>
      <mat-radio-button [labelPosition]="'before'" [checked]="isSelected(node)" (change)="selectNode(node)">
        {{node.name}}
      </mat-radio-button>
    </mat-tree-node>
  </mat-tree>
</div>

<p class="has-error" *ngIf="hasError()">{{"forms.Required" | translate}}</p>